
import React from 'react';
import StockManagement from '../components/StockManagement';

const StockManagementPage = () => {
  return (
    <div>
      <StockManagement />
    </div>
  );
};

export default StockManagementPage;
